import { GoogleMap, Marker, useLoadScript, Polyline, useJsApiLoader, Circle } from "@react-google-maps/api";
import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { googleMapKey } from "../../../constants/googleMapKey";



export default function MapModal(props) {

    const [center, setCenter] = useState({ lat: -33.847927, lng: 150.6517938 })
    const [selectedCoordinates, setSelectedCoordinates] = useState({lat: 0.0, lng: 0.0})
    const [loading, setLoading] = useState(false)
    const [radius, setRadius] = useState(0.0)

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: googleMapKey,
    });

    useEffect(() => {

        // check if the location is cached
        const cachedLocation = localStorage.getItem('centerPoint')
        if (cachedLocation) {
            const location = JSON.parse(cachedLocation)
            if (new Date().getTime() - location.timestamp < 1000 * 60 * 60 * 24) {
                setCenter(location)
                return
            }
        }

        fetch('https://ipapi.co/json/')
            .then(res => res.json())
            .then(response => {
                setCenter({ lat: response.latitude, lng: response.longitude })

                // cache the location
                localStorage.setItem('centerPoint', JSON.stringify({ lat: response.latitude, lng: response.longitude, timestamp: new Date().getTime()}))
            })
            .catch(err => console.log(err));
    }, [])

    return (
        <Modal show={props.show} fullscreen onHide={props.onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Select Location</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoaded && <GoogleMap
                    mapContainerStyle={{ width: '100%', height: '100%' }}
                    onClick={(e) => setSelectedCoordinates({lat: e.latLng.lat(), lng: e.latLng.lng()})}
                    center={center}
                    zoom={10}
                >
                    <Marker position={selectedCoordinates} onDragEnd={(e) => setSelectedCoordinates({lat: e.latLng.lat(), lng: e.latLng.lng()})} draggable={true} />
                    {props?.radius && <Circle center={selectedCoordinates} radius={parseFloat(radius)} />}
                </GoogleMap>}
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex align-items-end justify-content-end" style={{ columnGap: "1rem" }}>
                {props?.radius && <div>
                    <Form.Group className="w-100" controlId="formBasicRadius">
                        <Form.Label>Radius (in meter)</Form.Label>
                        <Form.Control type="number" value={radius} onChange={(e) => setRadius(parseFloat(e.target.value))} />
                    </Form.Group>
                </div>}
                <button className="btn btn-primary" onClick={() => {
                    setLoading(true)
                    if(props?.radius){
                        props.handleLocation({...selectedCoordinates, radius: radius}, {})
                        props.onHide()
                        return
                    }
                    fetch(`https://nominatim.openstreetmap.org/reverse?lat=${selectedCoordinates.lat}&lon=${selectedCoordinates.lng}&format=json&zoom=${props?.zoom ? props?.zoom : 13}&addressdetails=1`).then(res => res.json()).then(response => {

                        let address = {
                            area: "",
                            city: "",
                            state: "",
                            pincode: ""
                        }
                        if (response?.address) {
                            let area = ""
                            Object.keys(response?.address).forEach(key => {
                                if (key !== 'state_district' && key !== "state" && key !== "country" && key !== "country_code" && key !== "postcode" && !key.startsWith("ISO") && key!=="city") {
                                    area += response?.address[key] + ", "
                                }
                            })

                            let city = ""

                            if (response?.address?.city) {
                                city = response?.address?.city
                            } else if (response?.address?.town) {
                                city = response?.address?.town
                            } else if (response?.address?.village) {
                                city = response?.address?.village
                            }else {
                                city = response?.address?.state_district
                            }

                            address = { area: area, city: city, state: response?.address?.state, pincode: response?.address?.postcode}
                        }

                        props.handleLocation(selectedCoordinates, address)
                        props.onHide()
                    }).catch(err => {
                        console.log(err)
                        toast.error('Failed to get location details')
                    }).finally(() => setLoading(false))
                }} disabled={selectedCoordinates.lat===0.0 && selectedCoordinates.lng===0.0} >{loading ? "Loading..." : "Select"}</button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}